module.exports = __webpack_public_path__ + "img/ts.41d43f1a.png";